import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './Dropdown.scss';
import i18n from 'i18n';

class Dropdowns extends React.PureComponent<any> {
  constructor(props) {
    super(props);
    this.state = {
      moveItemGroup: 'hide',
      toggleIcon: '',
      DropdownToggle: 'DropdownToggle'
    };
    this.openmoveItemGroup = this.openmoveItemGroup.bind(this);
    this.handleDeleteLimitation = this.handleDeleteLimitation.bind(this);
    this.handleChangeOperateToINCLUDE =
      this.handleChangeOperateToINCLUDE.bind(this);
    this.handleChangeOperateToEXCLUDE =
      this.handleChangeOperateToEXCLUDE.bind(this);
    this.handleChangeOperateToPREFERRED =
      this.handleChangeOperateToPREFERRED.bind(this);
    this.handleChangeOperateToNONPREFERRED =
      this.handleChangeOperateToNONPREFERRED.bind(this);
  }

  openmoveItemGroup = () => {
    if (this.state['moveItemGroup'] === 'hide') {
      this.setState({
        moveItemGroup: '',
        toggleIcon: 'pointDown',
        DropdownToggle: 'DropdownToggleOn'
      });
    } else {
      this.setState({
        moveItemGroup: 'hide',
        toggleIcon: '',
        DropdownToggle: 'DropdownToggle'
      });
    }
  };

  handleDeleteLimitation = (event) => {
    event && event.stopPropagation();
    const { deleteLimitation, operate, type } = this.props;
    deleteLimitation(operate, type);
  };

  handleChangeOperateToINCLUDE = (event) => {
    event && event.stopPropagation();
    const { changeOperate, operate, type } = this.props;
    changeOperate(operate, type, 'include');
  };

  handleChangeOperateToEXCLUDE = (event) => {
    event && event.stopPropagation();
    const { changeOperate, operate, type } = this.props;
    changeOperate(operate, type, 'exclude');
  };

  handleChangeOperateToPREFERRED = (event) => {
    event && event.stopPropagation();
    const { changeOperate, operate, type } = this.props;
    changeOperate(operate, type, 'preferred');
  };

  handleChangeOperateToNONPREFERRED = (event) => {
    event && event.stopPropagation();
    const { changeOperate, operate, type } = this.props;
    changeOperate(operate, type, 'nonPreferred');
  };

  render() {
    const { operate, type, supportOperates, changeOperate } = this.props;
    return (
      <Dropdown>
        <Dropdown.Toggle
          variant='link'
          id={`${operate}-${type}-LimitationDropdown`}
          className='toggle'
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={this.handleDeleteLimitation}
            className='dropdownItem'
          >
            {i18n.t('common.buttons.delete')}
          </Dropdown.Item>
          {supportOperates && operate && changeOperate && (
            <>
              <div
                onClick={this.openmoveItemGroup}
                className={this.state['DropdownToggle']}
              >
                <Dropdown.Item disabled={true}>
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    className={this.state['toggleIcon']}
                  />{' '}
                  <span className='DropdownToggleText'>
                    {i18n.t('limitation.move.to')}
                  </span>
                </Dropdown.Item>
              </div>
              <div className={this.state['moveItemGroup']}>
                {supportOperates.includes('include') &&
                operate !== 'include' ? (
                  <Dropdown.Item
                    className='moveItem dropdownItem'
                    onClick={this.handleChangeOperateToINCLUDE}
                  >
                    {i18n.t('limitation.include')}
                  </Dropdown.Item>
                ) : null}
                {supportOperates.includes('preferred') &&
                operate !== 'preferred' ? (
                  <Dropdown.Item
                    className='moveItem dropdownItem'
                    onClick={this.handleChangeOperateToPREFERRED}
                  >
                    {i18n.t('limitation.preferred')}
                  </Dropdown.Item>
                ) : null}
                {supportOperates.includes('nonPreferred') &&
                operate !== 'nonPreferred' ? (
                  <Dropdown.Item
                    className='moveItem dropdownItem'
                    onClick={this.handleChangeOperateToNONPREFERRED}
                  >
                    {i18n.t('limitation.nonPreferred')}
                  </Dropdown.Item>
                ) : null}
                {supportOperates.includes('exclude') &&
                operate !== 'exclude' ? (
                  <Dropdown.Item
                    className='moveItem dropdownItem'
                    onClick={this.handleChangeOperateToEXCLUDE}
                  >
                    {i18n.t('limitation.exclude')}
                  </Dropdown.Item>
                ) : null}
              </div>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default Dropdowns;
